import navBarHomepage from '../modules/navbar-homepage';

let personController = () => {
    navBarHomepage.on();
};

export default personController;
